<script>
import dateEditor from './formDate';

export default {
    extends: dateEditor
};
</script>
